// extracted by mini-css-extract-plugin
module.exports = {"table":"Table-module--table--3AoUU","empty":"Table-module--empty--3Rfvm"};